import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPolicyScreen } from '@web/app/features/privacy/screen'

// Definimos la estructura de nuestros parámetros de búsqueda
type PrivacyPolicy = {
  id?: string // Lo ponemos opcional por si entran a la URL vacía
}

export const Route = createFileRoute('/privacy')({
  // Validamos los parámetros de búsqueda
  validateSearch: (search: Record<string, unknown>): PrivacyPolicy => {
    return {
      id: (search.id as string) || undefined,
    }
  },
  component: PrivacyPolicyScreen,
})
